import { Input, Typography } from "antd";
import styled from "styled-components";

export const StyledInput = styled(Input)`
    height: 47px;
    border-radius: 4px;
`;

export const StyledText = styled(Typography.Text)`
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    padding-bottom: 24px;
`;

export const StyledTitle = styled(Typography.Text)`
    font-size: 20px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    padding-bottom: 16px;
`;
